import './qcasino2/style';
import FormStructure from './qcasino2/form_structure';

export default FormStructure;